import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { IEvent, Webhook } from '../models/webhook.model';
import { apiParameters } from 'src/app/configs/api.params';
/**
 * @ignore
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  INIT_VALUE = null;

  private notificationsSubject = new BehaviorSubject<any>(this.INIT_VALUE);
  public notifications$ = this.notificationsSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private clickedNotificationSubject = new BehaviorSubject<any>(
    this.INIT_VALUE
  );
  public clickedNotification$ = this.notificationsSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  constructor(private httpClient: HttpClient) {}

  updateNotifications(notifications: any): void {
    this.notificationsSubject.next(notifications);
  }

  setNotification(notification: any): void {
    this.clickedNotificationSubject.next(notification);
  }

  uploadFile(body): Observable<any> {
    return this.httpClient
      .post(apiParameters.url + '/notifications/upload', body)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  sendNotification(body): Observable<any> {
    return this.httpClient
      .post(apiParameters.url + '/notifications', body)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getNotifications(page: number, limit: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        page: page.toString(),
        limit: limit.toString()
      }),
    };

    return this.httpClient
      .get(`${apiParameters.url}/notifications`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getUserNotifications(userId: string): Observable<any> {
    const httpOptions = {
      // headers: new HttpHeaders({
      //   page: '1',
      //   limit: '70',
      // }),
      params: new HttpParams().set('isSeen', 'false').set('status', 'active'),
    };

    return this.httpClient
      .get(`${apiParameters.url}/users/${userId}/notifications`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getUserNotification(userId: string, notificationId: string): Observable<any> {
    return this.httpClient
      .get(
        `${apiParameters.url}/users/${userId}/notifications/${notificationId}`
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  updateUserNotification(
    userId: string,
    notificationId: string,
    body
  ): Observable<any> {
    return this.httpClient
      .patch(
        `${apiParameters.url}/users/${userId}/notifications/${notificationId}`,
        body
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  deleteNotifications(userId: string): Observable<any> {
    const url = `${apiParameters.url}/users/${userId}/notifications`;

    return this.httpClient.delete(url);
  }
}
